<div [ngClass]="mergedSubtitleClass" [ngStyle]="style" (click)="hasEdit && onEdit()">
  <div class="truncate font-bold" [ngClass]="mergedTitleClass">
    {{ title }}
  </div>
  <ng-content select="[status]"></ng-content>
  @if (hasEdit) {
    <button class="flex flex-row items-center bg-transparent" [disabled]="disabled">
      @if (hasEditIcon) {
        <mat-icon class="text-primary icon-size-5" color="primary" [svgIcon]="iconEdit || 'heroicons_outline:pencil-square'"></mat-icon>
      }
      <span class="ml-1 text-nowrap font-semibold text-primary">{{ editButtonTitle }}</span>
    </button>
  }
  @if (hasAddNew) {
    <button
      mat-button
      class="flex min-w-[fit-content] flex-row items-center bg-transparent"
      [color]="'primary'"
      [disabled]="disabled"
      (click)="onAddNew()"
      style="max-height: 40px !important; min-height: 20px !important; min-width: auto !important; height: 32px !important">
      <mat-icon class="icon-size-5" color="primary" [svgIcon]="'heroicons_outline:plus-circle'"></mat-icon>
      <span class="ml-1 text-nowrap font-semibold dark:text-primary">{{ addNewTitle || ('button.add-new' | transloco) }}</span>
    </button>
  }
</div>
